import { RouteRecordRaw } from 'vue-router';
import { AdminBranchesPage } from '@/pages/admin';

export const routeName = 'AdminFiliais';

export const route: RouteRecordRaw = {
  path: 'filiais',
  name: routeName,
  component: AdminBranchesPage,
  meta: {
    requiresAuth: true,
    breadcrumb: 'Filiais',
    permissions: [{ action: 'manageBranches', subject: 'Admin' }],
  },
};
